import React, { useState } from "react";
import { Sparkles, PencilLine } from "lucide-react";
import { IA_DOCS_PAUSADA } from "@/lib/pausas";

const Opcion = ({ testid, icon: I, label, desc, onClick }) => (
  <button data-testid={testid} onClick={onClick}
    className="w-full flex items-center gap-4 bg-white border border-[#E5DFD5] rounded-2xl p-4 text-left hover:border-[#3A6B56] transition-colors min-h-[72px]">
    <span className="shrink-0 w-12 h-12 rounded-xl bg-[#E8F0EC] flex items-center justify-center"><I size={24} className="text-[#3A6B56]" /></span>
    <span><span className="block font-heading font-bold text-lg text-[#1C2421]">{label}</span><span className="block text-sm text-[#6E7A74]">{desc}</span></span>
  </button>
);

const AvisoNoMedico = () => <p className="text-sm text-[#6E7A74] mt-3" data-testid="subida-aviso-no-medico">No subas informes médicos ni recetas: AL DÍA no los admite en esta fase.</p>;

export const TEXTO_CON_IA = "AL DÍA leerá el contenido para ayudarte a organizarlo.";
export const TEXTO_SIN_IA = "El contenido se guardará sin enviarlo a la IA ni extraer automáticamente sus datos.";

// Las dos opciones, siempre ANTES de cualquier análisis.
export const OpcionesIA = ({ prefijo = "subida", archivo, onAnalizar, onSinIA, onCancelar, ocupado = false }) => (
  <div data-testid={`${prefijo}-elegir-analisis`}>
    <h2 className="font-heading text-2xl font-bold text-[#1C2421] pr-12">¿Cómo quieres guardarlo?</h2>
    {archivo && <p className="text-base text-[#4A5550] mt-1 truncate" data-testid={`${prefijo}-archivo`}>{archivo}</p>}
    <AvisoNoMedico />
    <div className="space-y-3 mt-5">
      <Opcion testid={`${prefijo}-con-ia`} icon={Sparkles} label="Analizar con IA" desc={TEXTO_CON_IA} onClick={ocupado ? undefined : onAnalizar} />
      <Opcion testid={`${prefijo}-sin-ia`} icon={PencilLine} label="Guardar sin análisis" desc={TEXTO_SIN_IA} onClick={ocupado ? undefined : onSinIA} />
    </div>
    <button data-testid={`${prefijo}-cancelar`} onClick={onCancelar} className="w-full mt-3 min-h-[44px] text-[#4A5550] font-semibold">Cancelar</button>
  </div>
);

export const ElegirAnalisis = ({ archivo, onAnalizar, onSinIA, onCancelar, ocupado, soloSinIA = false, pedirNoClinico = null }) => {
  const [sinIA, setSinIA] = useState(IA_DOCS_PAUSADA || soloSinIA);
  const [nombre, setNombre] = useState((archivo || "").replace(/\.[^.]+$/, ""));
  if (!sinIA) return (
    <OpcionesIA archivo={archivo} onAnalizar={onAnalizar} onCancelar={onCancelar}
      onSinIA={() => (pedirNoClinico ? pedirNoClinico(() => setSinIA(true)) : setSinIA(true))} />
  );
  return (
    <div data-testid="subida-sin-ia-form">
      <h2 className="font-heading text-2xl font-bold text-[#1C2421] pr-12">Guardar sin análisis</h2>
      <AvisoNoMedico />
      {IA_DOCS_PAUSADA && <p className="text-sm text-[#4A5550] mt-2" data-testid="subida-ia-pausada">El análisis automático de documentos con IA está temporalmente suspendido. Ponle tú el nombre.</p>}
      <label className="block text-base font-semibold text-[#1C2421] mt-4" htmlFor="sin-ia-nombre">Nombre del documento</label>
      <input id="sin-ia-nombre" data-testid="subida-sin-ia-nombre" value={nombre} maxLength={120} onChange={(e) => setNombre(e.target.value)}
        className="w-full mt-2 min-h-[52px] px-4 rounded-xl border border-[#E5DFD5] bg-white text-base" />
      <p className="text-sm text-[#4A5550] mt-3 bg-[#F6F3EE] rounded-xl p-3" data-testid="subida-sin-ia-aviso">El documento se guardará en AL DÍA, en Documentos, aunque no se analice con IA. No se enviará a ningún servicio de IA y podrás organizarlo tú después.</p>
      <button data-testid="subida-sin-ia-guardar" disabled={!nombre.trim() || ocupado} onClick={() => onSinIA(nombre.trim())}
        className="w-full mt-5 min-h-[48px] rounded-xl bg-[#3A6B56] text-white font-semibold text-base disabled:opacity-50">{ocupado ? "Guardando…" : "Guardar sin análisis"}</button>
      <button data-testid="subida-sin-ia-volver" onClick={() => (IA_DOCS_PAUSADA || soloSinIA ? onCancelar() : setSinIA(false))} className="w-full mt-2 min-h-[44px] text-[#4A5550] font-semibold">{IA_DOCS_PAUSADA || soloSinIA ? "Cancelar" : "Volver"}</button>
    </div>
  );
};
